import { createReducer, on } from '@ngrx/store';
import { StationTagsActions } from './station-tags.actions';
import { GenericState } from '../../shared/types';
import { TableSummary } from 'daisy-design-system-front';

export const stationTRagsFeatureKey = 'Station-tags';

export type StationsTagsState = GenericState<TableSummary>

const initialStation: StationsTagsState = {
    loading: true
};

export const stationTagsReducer = createReducer<StationsTagsState>(
    initialStation,
    on(
        StationTagsActions.fetchSuccess,
        (_, { data }): StationsTagsState => ({
            loading: false,
            hasError: false,
            data: {rows: data},

        })
    ),
    on(StationTagsActions.fetchFailure,
        (_, {message}): StationsTagsState => ({
            loading: false,
            hasError: true,
            errorMessage: message
        })
    ),
    on(StationTagsActions.search,
        (): StationsTagsState => ({
            loading: true,
        })
    )
);
